import React, { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import './Account.css'

const API_BASE = 'https://backend.alephmedia.ro/api'

// Lista de județe/sectoare pentru dropdown
const JUDETE_SECTOARE = [
  'Sectorul 1', 'Sectorul 2', 'Sectorul 3', 'Sectorul 4', 'Sectorul 5', 'Sectorul 6',
  'Alba', 'Arad', 'Argeș', 'Bacău', 'Bihor', 'Bistrița-Năsăud', 'Botoșani', 'Brăila',
  'Brașov', 'Buzău', 'Călărași', 'Caraș-Severin', 'Cluj', 'Constanța', 'Covasna',
  'Dâmbovița', 'Dolj', 'Galați', 'Giurgiu', 'Gorj', 'Harghita', 'Hunedoara', 'Ialomița',
  'Iași', 'Ilfov', 'Maramureș', 'Mehedinți', 'Mureș', 'Neamț', 'Olt', 'Prahova',
  'Sălaj', 'Satu Mare', 'Sibiu', 'Suceava', 'Teleorman', 'Timiș', 'Tulcea', 'Vâlcea',
  'Vaslui', 'Vrancea'
]

// Lista de domenii de activitate
const DOMENII_ACTIVITATE = [
  { value: '', label: '-' },
  { value: 'Administratie Publica: Local', label: 'Administratie Publica: Local' },
  { value: 'Administratie Publica: National', label: 'Administratie Publica: National' },
  { value: 'Agricultura', label: 'Agricultura' },
  { value: 'Asigurari', label: 'Asigurari' },
  { value: 'Auto si Aerospatial', label: 'Auto si Aerospatial' },
  { value: 'Bancar', label: 'Bancar' },
  { value: 'Chimice', label: 'Chimice' },
  { value: 'Comert en-detail', label: 'Comert en-detail' },
  { value: 'Comert en-gross', label: 'Comert en-gross' },
  { value: 'Constructii', label: 'Constructii' },
  { value: 'Consultanta', label: 'Consultanta' },
  { value: 'Divertisment', label: 'Divertisment' },
  { value: 'Educatie', label: 'Educatie' },
  { value: 'FMCG', label: 'FMCG' },
  { value: 'High-Tech', label: 'High-Tech' },
  { value: 'Imobiliare', label: 'Imobiliare' },
  { value: 'Ind Farmaceutica', label: 'Ind Farmaceutica' },
  { value: 'Ind. Petroliera si Minerit', label: 'Ind. Petroliera si Minerit' },
  { value: 'Ind. Prelucratoare', label: 'Ind. Prelucratoare' },
  { value: 'Juridic', label: 'Juridic' },
  { value: 'Media', label: 'Media' },
  { value: 'ONG', label: 'ONG' },
  { value: 'Proiectare', label: 'Proiectare' },
  { value: 'Publishing', label: 'Publishing' },
  { value: 'Sanatate', label: 'Sanatate' },
  { value: 'Servicii Financiare', label: 'Servicii Financiare' },
  { value: 'Telecomunicatii', label: 'Telecomunicatii' },
  { value: 'Transport', label: 'Transport' },
  { value: 'Utilitati', label: 'Utilitati' },
]

const Account = () => {
  const navigate = useNavigate()
  const [user, setUser] = useState(null)
  const [payments, setPayments] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)
  const [editMode, setEditMode] = useState(false)
  const [passwordMode, setPasswordMode] = useState(false)
  const [avatarUploading, setAvatarUploading] = useState(false)
  const avatarInputRef = useRef(null)
  
  const [feedStatus, setFeedStatus] = useState(null)
  const [feedLoading, setFeedLoading] = useState(false)
  const [feedActivating, setFeedActivating] = useState(false)

  const [editForm, setEditForm] = useState({
    first_name: '',
    last_name: '',
    phone: '',
    judet_sector: '',
    localitate: '',
    adresa: '',
    compania: '',
    domeniu_activitate: '',
    functia: ''
  })

  const [passwordForm, setPasswordForm] = useState({
    old_password: '',
    password: '',
    password_confirmation: ''
  })

  useEffect(() => {
    const token = localStorage.getItem('authToken')
    if (!token) {
      navigate('/v4.0/login')
      return
    }

    fetchAccount()
    fetchPayments()
    fetchFeedStatus()
  }, [navigate])

  const fetchAccount = async () => {
    const token = localStorage.getItem('authToken')
    try {
      const response = await fetch(`${API_BASE}/account`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        }
      })

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('authToken')
          navigate('/v4.0/login')
          return
        }
        throw new Error('Nu am putut încărca datele contului')
      }

      const data = await response.json()
      if (data.success && data.data) {
        setUser(data.data)
        setEditForm({
          first_name: data.data.first_name || '',
          last_name: data.data.last_name || '',
          phone: data.data.phone || '',
          judet_sector: data.data.judet_sector || '',
          localitate: data.data.localitate || '',
          adresa: data.data.adresa || '',
          compania: data.data.compania || '',
          domeniu_activitate: data.data.domeniu_activitate || '',
          functia: data.data.functia || ''
        })
      }
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const fetchPayments = async () => {
    const token = localStorage.getItem('authToken')
    try {
      const response = await fetch(`${API_BASE}/account/payments`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        }
      })

      if (response.ok) {
        const data = await response.json()
        if (data.success && data.data) {
          setPayments(data.data)
        }
      }
    } catch (err) {
      console.error('Failed to fetch payments', err)
    }
  }

  const fetchFeedStatus = async () => {
    const token = localStorage.getItem('authToken')
    if (!token) return

    try {
      const response = await fetch(`${API_BASE}/partner-feed/status`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        }
      })
      if (response.ok) {
        const data = await response.json()
        if (data.success) {
          setFeedStatus(data.data)
        }
      }
    } catch (err) {
      console.error('Failed to fetch feed status', err)
    }
  }

  const handleActivateFeed = async () => {
    setFeedActivating(true)
    setError(null)
    const token = localStorage.getItem('authToken')
    try {
      const response = await fetch(`${API_BASE}/partner-feed/activate`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ language: 'ro' })
      })
      const data = await response.json()
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Nu s-a putut activa feed-ul')
      }
      setSuccess('Feed-ul de știri a fost activat!')
      fetchFeedStatus()
      setTimeout(() => setSuccess(null), 3000)
    } catch (err) {
      setError(err.message)
    } finally {
      setFeedActivating(false)
    }
  }

  const handleDeactivateFeed = async () => {
    if (!window.confirm('Ești sigur că vrei să dezactivezi feed-ul de știri?')) return
    setError(null)
    const token = localStorage.getItem('authToken')
    try {
      const response = await fetch(`${API_BASE}/partner-feed/deactivate`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        }
      })
      const data = await response.json()
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Nu s-a putut dezactiva feed-ul')
      }
      setSuccess('Feed-ul a fost dezactivat.')
      setFeedStatus({ active: false })
      setTimeout(() => setSuccess(null), 3000)
    } catch (err) {
      setError(err.message)
    }
  }

  const handleUpdateProfile = async (e) => {
    e.preventDefault()
    setError(null)
    setSuccess(null)

    const token = localStorage.getItem('authToken')
    try {
      const response = await fetch(`${API_BASE}/account/update`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(editForm)
      })

      const data = await response.json()
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Actualizare eșuată')
      }

      setSuccess('Datele au fost actualizate cu succes!')
      setEditMode(false)
      fetchAccount()
      
      const userData = JSON.parse(localStorage.getItem('userData') || '{}')
      localStorage.setItem('userData', JSON.stringify({
        ...userData,
        first_name: editForm.first_name,
        last_name: editForm.last_name,
        phone: editForm.phone,
        judet_sector: editForm.judet_sector,
        localitate: editForm.localitate,
        adresa: editForm.adresa,
        compania: editForm.compania,
        domeniu_activitate: editForm.domeniu_activitate,
        functia: editForm.functia
      }))

      setTimeout(() => setSuccess(null), 3000)
    } catch (err) {
      setError(err.message)
    }
  }

  const handleChangePassword = async (e) => {
    e.preventDefault()
    setError(null)
    setSuccess(null)

    if (passwordForm.password !== passwordForm.password_confirmation) {
      setError('Parolele nu se potrivesc')
      return
    }

    const token = localStorage.getItem('authToken')
    try {
      const response = await fetch(`${API_BASE}/account/change-password`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(passwordForm)
      })

      const data = await response.json()
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Schimbare parolă eșuată')
      }

      setSuccess('Parola a fost schimbată cu succes!')
      setPasswordMode(false)
      setPasswordForm({ old_password: '', password: '', password_confirmation: '' })
      setTimeout(() => setSuccess(null), 3000)
    } catch (err) {
      setError(err.message)
    }
  }

  const handleAvatarChange = async (e) => {
    const file = e.target.files?.[0]
    if (!file) return

    // Validare tip fișier
    if (!file.type.startsWith('image/')) {
      setError('Te rugăm să selectezi o imagine validă')
      return
    }

    // Validare dimensiune (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      setError('Imaginea trebuie să fie mai mică de 5MB')
      return
    }

    setAvatarUploading(true)
    setError(null)

    const token = localStorage.getItem('authToken')
    const formData = new FormData()
    formData.append('avatar', file)

    try {
      const response = await fetch(`${API_BASE}/account/avatar`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        },
        body: formData
      })

      const data = await response.json()
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Încărcare eșuată')
      }

      setSuccess('Poza de profil a fost actualizată!')
      fetchAccount()
      
      // Actualizăm și în localStorage
      const userData = JSON.parse(localStorage.getItem('userData') || '{}')
      localStorage.setItem('userData', JSON.stringify({
        ...userData,
        avatar_url: data.data.avatar_url
      }))

      setTimeout(() => setSuccess(null), 3000)
    } catch (err) {
      setError(err.message)
    } finally {
      setAvatarUploading(false)
      // Reset input
      if (avatarInputRef.current) {
        avatarInputRef.current.value = ''
      }
    }
  }

  const handleLogout = () => {
    localStorage.removeItem('authToken')
    localStorage.removeItem('userData')
    localStorage.removeItem('subscriptionId')
    localStorage.removeItem('subscriptionLevel')
    localStorage.removeItem('__paypal_storage__')
    navigate('/v4.0/login')
  }

  if (loading) {
    return (
      <div className="v4-account-root">
        <div className="v4-account-loading">
          <div className="v4-account-spinner"></div>
          <p>Se încarcă...</p>
        </div>
      </div>
    )
  }

  if (error && !user) {
    return (
      <div className="v4-account-root">
        <div className="v4-account-error-page">
          <p>{error}</p>
          <button onClick={() => navigate('/v4.0')}>← Înapoi</button>
        </div>
      </div>
    )
  }

  return (
    <div className="v4-account-root">
      <div className="v4-account-container">
        <div className="v4-account-header">
          <button className="v4-account-back-btn" onClick={() => navigate('/v4.0')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="19" y1="12" x2="5" y2="12"/>
              <polyline points="12 19 5 12 12 5"/>
            </svg>
          </button>
          <h1>Profilul meu</h1>
          <div 
            className={`v4-account-avatar ${avatarUploading ? 'v4-account-avatar--uploading' : ''}`}
            onClick={() => avatarInputRef.current?.click()}
            title="Click pentru a schimba poza de profil"
          >
            {user?.avatar_url ? (
              <img src={user.avatar_url} alt="Avatar" className="v4-account-avatar-img" />
            ) : (
              user?.first_name?.[0]?.toUpperCase() || user?.name?.[0]?.toUpperCase() || 'U'
            )}
            <div className="v4-account-avatar-overlay">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
                <circle cx="12" cy="13" r="4"/>
              </svg>
            </div>
            <input
              ref={avatarInputRef}
              type="file"
              accept="image/*"
              onChange={handleAvatarChange}
              className="v4-account-avatar-input"
            />
          </div>
        </div>

        {error && <div className="v4-account-error">{error}</div>}
        {success && <div className="v4-account-success">{success}</div>}

        {user && (
          <div className="v4-account-content">
            <div className="v4-account-card">
              <div className="v4-account-card-header">
                <h2>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                  Informații personale
                </h2>
                {!editMode && (
                  <button className="v4-account-edit-btn" onClick={() => setEditMode(true)}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                    </svg>
                    Editează
                  </button>
                )}
              </div>

              {editMode ? (
                <form onSubmit={handleUpdateProfile} className="v4-account-form">
                  <div className="v4-account-field">
                    <label>Prenume</label>
                    <input
                      type="text"
                      value={editForm.first_name}
                      onChange={(e) => setEditForm({ ...editForm, first_name: e.target.value })}
                      placeholder="Prenume"
                    />
                  </div>
                  <div className="v4-account-field">
                    <label>Nume</label>
                    <input
                      type="text"
                      value={editForm.last_name}
                      onChange={(e) => setEditForm({ ...editForm, last_name: e.target.value })}
                      placeholder="Nume"
                    />
                  </div>
                  <div className="v4-account-field">
                    <label>Telefon</label>
                    <input
                      type="tel"
                      value={editForm.phone}
                      onChange={(e) => setEditForm({ ...editForm, phone: e.target.value })}
                      placeholder="07xxxxxxxx"
                    />
                  </div>
                  <div className="v4-account-field">
                    <label>Județ/Sector</label>
                    <select
                      value={editForm.judet_sector}
                      onChange={(e) => setEditForm({ ...editForm, judet_sector: e.target.value })}
                    >
                      <option value="">Selectează...</option>
                      {JUDETE_SECTOARE.map(j => (
                        <option key={j} value={j}>{j}</option>
                      ))}
                    </select>
                  </div>
                  <div className="v4-account-field">
                    <label>Localitate</label>
                    <input
                      type="text"
                      value={editForm.localitate}
                      onChange={(e) => setEditForm({ ...editForm, localitate: e.target.value })}
                      placeholder="București"
                    />
                  </div>
                  <div className="v4-account-field">
                    <label>Adresă</label>
                    <input
                      type="text"
                      value={editForm.adresa}
                      onChange={(e) => setEditForm({ ...editForm, adresa: e.target.value })}
                      placeholder="Str. Exemplu, Nr. 1"
                    />
                  </div>
                  <div className="v4-account-field">
                    <label>Companie</label>
                    <input
                      type="text"
                      value={editForm.compania}
                      onChange={(e) => setEditForm({ ...editForm, compania: e.target.value })}
                      placeholder="Numele companiei"
                    />
                  </div>
                  <div className="v4-account-field">
                    <label>Domeniu de activitate</label>
                    <select
                      value={editForm.domeniu_activitate}
                      onChange={(e) => setEditForm({ ...editForm, domeniu_activitate: e.target.value })}
                    >
                      {DOMENII_ACTIVITATE.map(d => (
                        <option key={d.value} value={d.value}>{d.label}</option>
                      ))}
                    </select>
                  </div>
                  <div className="v4-account-field">
                    <label>Funcție</label>
                    <input
                      type="text"
                      value={editForm.functia}
                      onChange={(e) => setEditForm({ ...editForm, functia: e.target.value })}
                      placeholder="Director, Manager, etc."
                    />
                  </div>
                  <div className="v4-account-form-actions">
                    <button type="submit" className="v4-account-save-btn">Salvează</button>
                    <button type="button" className="v4-account-cancel-btn" onClick={() => setEditMode(false)}>
                      Anulează
                    </button>
                  </div>
                </form>
              ) : (
                <div className="v4-account-info">
                  <div className="v4-account-info-item">
                    <span className="v4-account-label">Nume complet:</span>
                    <span className="v4-account-value">
                      {user.first_name || ''} {user.last_name || user.name || 'Nu ai completat'}
                    </span>
                  </div>
                  <div className="v4-account-info-item">
                    <span className="v4-account-label">Email:</span>
                    <span className="v4-account-value">{user.email}</span>
                  </div>
                  <div className="v4-account-info-item">
                    <span className="v4-account-label">Telefon:</span>
                    <span className="v4-account-value">{user.phone || 'Nu ai adăugat'}</span>
                  </div>
                  <div className="v4-account-info-item">
                    <span className="v4-account-label">Județ/Sector:</span>
                    <span className="v4-account-value">{user.judet_sector || 'Nu ai adăugat'}</span>
                  </div>
                  <div className="v4-account-info-item">
                    <span className="v4-account-label">Localitate:</span>
                    <span className="v4-account-value">{user.localitate || 'Nu ai adăugat'}</span>
                  </div>
                  <div className="v4-account-info-item">
                    <span className="v4-account-label">Adresă:</span>
                    <span className="v4-account-value">{user.adresa || 'Nu ai adăugat'}</span>
                  </div>
                  <div className="v4-account-info-item">
                    <span className="v4-account-label">Companie:</span>
                    <span className="v4-account-value">{user.compania || 'Nu ai adăugat'}</span>
                  </div>
                  <div className="v4-account-info-item">
                    <span className="v4-account-label">Domeniu:</span>
                    <span className="v4-account-value">{user.domeniu_activitate || 'Nu ai adăugat'}</span>
                  </div>
                  <div className="v4-account-info-item">
                    <span className="v4-account-label">Funcție:</span>
                    <span className="v4-account-value">{user.functia || 'Nu ai adăugat'}</span>
                  </div>
                </div>
              )}
            </div>

            <div className="v4-account-card">
              <div className="v4-account-card-header">
                <h2>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                  Securitate
                </h2>
                {!passwordMode && (
                  <button className="v4-account-edit-btn" onClick={() => setPasswordMode(true)}>
                    Schimbă parola
                  </button>
                )}
              </div>

              {passwordMode && (
                <form onSubmit={handleChangePassword} className="v4-account-form">
                  <div className="v4-account-field">
                    <label>Parola veche</label>
                    <input
                      type="password"
                      value={passwordForm.old_password}
                      onChange={(e) => setPasswordForm({ ...passwordForm, old_password: e.target.value })}
                      placeholder="••••••••"
                      required
                    />
                  </div>
                  <div className="v4-account-field">
                    <label>Parola nouă</label>
                    <input
                      type="password"
                      value={passwordForm.password}
                      onChange={(e) => setPasswordForm({ ...passwordForm, password: e.target.value })}
                      placeholder="••••••••"
                      required
                      minLength={8}
                    />
                  </div>
                  <div className="v4-account-field">
                    <label>Confirmă parola</label>
                    <input
                      type="password"
                      value={passwordForm.password_confirmation}
                      onChange={(e) => setPasswordForm({ ...passwordForm, password_confirmation: e.target.value })}
                      placeholder="••••••••"
                      required
                      minLength={8}
                    />
                  </div>
                  <div className="v4-account-form-actions">
                    <button type="submit" className="v4-account-save-btn">Schimbă parola</button>
                    <button type="button" className="v4-account-cancel-btn" onClick={() => {
                      setPasswordMode(false)
                      setPasswordForm({ old_password: '', password: '', password_confirmation: '' })
                    }}>
                      Anulează
                    </button>
                  </div>
                </form>
              )}
            </div>

            {user.subscription_type && (
              <div className="v4-account-card v4-account-subscription">
                <div className="v4-account-card-header">
                  <h2>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                    </svg>
                    Abonament
                  </h2>
                </div>
                <div className="v4-account-info">
                  <div className="v4-account-info-item">
                    <span className="v4-account-label">Plan:</span>
                    <span className={`v4-account-badge v4-account-badge--${user.subscription_type}`}>
                      {user.subscription_type === 'premium' ? 'Premium' : user.subscription_type === 'plus' ? 'Plus' : user.subscription_type}
                    </span>
                  </div>
                  <div className="v4-account-info-item">
                    <span className="v4-account-label">Status:</span>
                    <span className="v4-account-value">
                      {user.subscription_status === 'active' ? '✓ Activ' : user.subscription_status || 'Inactiv'}
                    </span>
                  </div>
                  {user.subscription_expires_at && (
                    <div className="v4-account-info-item">
                      <span className="v4-account-label">Expiră la:</span>
                      <span className="v4-account-value">
                        {new Date(user.subscription_expires_at).toLocaleDateString('ro-RO')}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {user.subscription_type === 'premium' && (
              <div className="v4-account-card v4-account-feed">
                <div className="v4-account-card-header">
                  <h2>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 11a9 9 0 0 1 9 9"/>
                      <path d="M4 4a16 16 0 0 1 16 16"/>
                      <circle cx="5" cy="19" r="1"/>
                    </svg>
                    Feed Știri Alephia
                  </h2>
                  {feedStatus?.active && (
                    <button className="v4-account-edit-btn" onClick={() => navigate('/v4.0/partner-feed')}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="9 18 15 12 9 6"/>
                      </svg>
                      Deschide
                    </button>
                  )}
                </div>

                {!feedStatus || !feedStatus.active ? (
                  <div className="v4-account-feed-inactive">
                    <p className="v4-account-feed-desc">
                      Activează feed-ul de știri personalizat. Primești știri filtrate automat pe baza preferințelor tale.
                    </p>
                    <button
                      className="v4-account-save-btn"
                      onClick={handleActivateFeed}
                      disabled={feedActivating}
                    >
                      {feedActivating ? 'Se activează...' : 'Activează Feed Știri'}
                    </button>
                  </div>
                ) : (
                  <div className="v4-account-info">
                    <div className="v4-account-info-item">
                      <span className="v4-account-label">Status:</span>
                      <span className="v4-account-value" style={{ color: '#059669' }}>Activ</span>
                    </div>
                    {feedStatus.unread_count > 0 && (
                      <div className="v4-account-info-item">
                        <span className="v4-account-label">Necitite:</span>
                        <span className="v4-account-badge v4-account-badge--premium">
                          {feedStatus.unread_count}
                        </span>
                      </div>
                    )}
                    <div className="v4-account-info-item">
                      <span className="v4-account-label">Limba:</span>
                      <span className="v4-account-value">{feedStatus.language === 'ro' ? 'Română' : feedStatus.language}</span>
                    </div>
                    {feedStatus.filters && feedStatus.filters.length > 0 && (
                      <div className="v4-account-info-item" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
                        <span className="v4-account-label">Filtre active:</span>
                        <div className="v4-account-feed-filters">
                          {feedStatus.filters.map((f, i) => (
                            <span key={i} className={`v4-account-feed-filter-tag v4-account-feed-filter-tag--${f.match_mode}`}>
                              {f.match_mode === 'exclude' ? '−' : '+'} {f.filter_type}: {f.filter_value}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                    <div className="v4-account-info-item" style={{ borderBottom: 'none' }}>
                      <button
                        className="v4-account-feed-configure-btn"
                        onClick={() => navigate('/v4.0/partner-feed?configure=1')}
                      >
                        Configurează filtre
                      </button>
                      <button
                        className="v4-account-feed-deactivate-btn"
                        onClick={handleDeactivateFeed}
                      >
                        Dezactivează
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}

            {payments.length > 0 && (
              <div className="v4-account-card">
                <div className="v4-account-card-header">
                  <h2>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
                      <line x1="1" y1="10" x2="23" y2="10"/>
                    </svg>
                    Istoric plăți
                  </h2>
                </div>
                <div className="v4-account-payments">
                  {payments.map((payment, index) => (
                    <div key={payment.id || index} className="v4-account-payment-item">
                      <div className="v4-account-payment-info">
                        <div className="v4-account-payment-amount">
                          {payment.amount} {payment.currency || 'RON'}
                        </div>
                        <div className="v4-account-payment-date">
                          {new Date(payment.created_at).toLocaleDateString('ro-RO', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                          })}
                        </div>
                      </div>
                      <div className={`v4-account-payment-status v4-account-payment-status--${payment.status}`}>
                        {payment.status === 'completed' ? '✓ Finalizată' : payment.status}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="v4-account-actions">
              <button className="v4-account-logout" onClick={handleLogout}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                  <polyline points="16 17 21 12 16 7"/>
                  <line x1="21" y1="12" x2="9" y2="12"/>
                </svg>
                Deconectare
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Account

